import MenuOptions from "../../components/order/menu/MenuOptions";
import activateAccount from "../../controllers/user/activateAccount";
import deActivateAccount from "../../controllers/user/deactivateAccount";

export default function CustomerMenu({
  order,
  mobile,
  setAccountManagerModal,
  setUploadModal,
  setSendEmailModal,
  setTopupModal,
  setDebitModal,
  setActivateModal,
  setOfficeIdModal,
  onDisabledAccount,
  callback,
}) {
  const isAccountActive = order?.accountStatus === "Active";

  const handleUserAccountStatus = async () => {
    onDisabledAccount?.(true);
    //   setLoading({ ...loading, disable: true });
    const res = await (
      isAccountActive
        ? deActivateAccount(order?._id)
        : activateAccount(order?._id)
    ).finally(() => {
      // setLoading({ ...loading, disable: false });
      onDisabledAccount?.(false);
    });
    if (res.return) {
      callback(res?.data?.data);
    }
  };

  const menu = [
    {
      label: "Assign Account Manager",
      action: () => {
        setAccountManagerModal?.(true);
      },
      visible: true,
    },
    {
      label: "Upload Documents",
      action: () => {
        setUploadModal?.(true);
      },
      visible: true,
    },
    {
      label: "Send Email",
      action: () => {
        setSendEmailModal?.(true);
      },
      visible: true,
    },
    {
      label: "Top-up Wallet",
      action: () => {
        setTopupModal?.(true);
      },
      visible: true,
    },
    {
      label: "Debit Wallet",
      action: () => {
        setDebitModal?.(true);
      },
      visible: true,
    },
    {
      label: "Office ID",
      action: () => {
        setOfficeIdModal?.(true);
      },
      visible: true,
    },
    {
      label: "View Business",
      action: () => {
        setActivateModal?.(true);
      },
      visible:
        order?.detail?.isVerified || order?.detail?.requestedVerification,
    },
    {
      label: order?.detail?.isVerified
        ? "Deactivate Business"
        : "Activate Business",
      action: () => {
        setActivateModal?.(true);
      },
      visible:
        order?.detail?.isVerified || order?.detail?.requestedVerification,
    },
    {
      label: isAccountActive ? "Disable Account" : "Enable Account",
      action: () => {
        handleUserAccountStatus();
        onDisabledAccount?.(true);
      },
      visible: true,
    },
  ];

  return (
    <>
      <div className="hidden"></div>
      <MenuOptions mobile={mobile} menu={menu} />
    </>
  );
}
// Stay menu
